module.exports = __webpack_public_path__ + "img/16l010-02.418c09f4.png";